// src/theme.ts
import { inputBaseClasses } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import * as colors from '../partials/colors';
const theme = createTheme({
  typography: {
    fontFamily: "'Rubik', sans-serif",
  },
  palette: {
    // Customize the primary color to use a specific shade of blue
    primary: {
      main: colors.docGeniusPalette.primaryBlue,
    },
    secondary: {
      main: '#2A5BDF',
    },
    action: {
      disabled: colors.colorPalette.disabledGray2,
    },
  },
  components: {
    MuiChip: {
      styleOverrides: {
        outlined: {
          color: colors.docGeniusPalette.neutralGray,
        },
        filled: {
          backgroundColor: '#DBE3EF',
          color: colors.docGeniusPalette.primaryBlue,
          '&:hover': {
            backgroundColor: '#DBE3EF',
            color: colors.docGeniusPalette.primaryBlue,
          },
        },
        root: {
          borderRadius: '8px',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          height: '40px',
          borderRadius: '8px',
          border: 'none',
          outline: 'none',
        },
        select: {
          alignItems: 'center',
          display: 'flex',
          '& .MuiSvgIcon-root': {
            display: 'none',
          },
        },
        icon: {
          color: colors.docGeniusPalette.primaryBlue,
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          minWidth: '256px',
        },
        paper: {
          borderRadius: '8px',
          boxShadow: '0px 5px 10px 0px #1D3F9C33',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          backgroundColor: 'white',
          borderBottom: `1px solid #C9CACB`,
          '&.Mui-selected': {
            backgroundColor: 'white',
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          border: 'none',
          outline: 'none',
          [`& .${inputBaseClasses.root}`]: {
            borderRadius: '8px',
          },
          ['&.QuoteAutocomplete']: {
            width: '100%',
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        track: {
          backgroundColor: colors.colorPalette.disabledGray1,
          opacity: 1,
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: '14px',
          fontWeight: '500',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: '#B7B9C0',
            border: '1px solid #B7B9C0',
            backgroundColor: '#E5E5E5',
          },
        },
        input: {
          '&.Mui-disabled': {
            cursor: 'not-allowed',
            padding: '8px 16px',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          lineHeight: 1,
          backgroundColor: 'white',
          ['&.MuiInputLabel-disabled']: {
            backgroundColor: 'transparent',
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: '8px',
          maxWidth: 216,
          backgroundColor: colors.colorPalette.neutralGray3,
          padding: '8px 16px',
          fontWeight: 400,
        },
        arrow: {
          color: colors.colorPalette.neutralGray3,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.MuiInputLabel-root': {
            '&.Mui-disabled': {
              backgroundColor: '#E5E5E5',
            },
          },
        },
      },
    },
    MuiButtonGroup: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        title: {
          fontSize: '14px',
          lineHeight: '24px',
          fontWeight: '500',
          color: '#717273',
        },
      },
    },
  },
});

export default theme;
